import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class LocationReportService extends Service{
    constructor() {
        super();
        this.baseURL = 'locationReport';
    }

    findInstalledLocation() {
        return fetch(SERVER_URL + this.baseURL + "/findInstalledLocation", {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findUninstalledLocation() {
        return fetch(SERVER_URL + this.baseURL + "/findUninstalledLocation", {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findWillInstallLocation() {
        return fetch(SERVER_URL + this.baseURL + "/findWillInstallLocation", {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}